import React, { forwardRef } from "react"

import { DropdownButtonProps, dropdownProps } from "./DropdownButton"
import { IconButton, IconButtonProps } from "./IconButton"

export const DropdownIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps & DropdownButtonProps
>((props, ref) => {
  return <IconButton ref={ref} {...props} {...dropdownProps(props)} />
})

DropdownIconButton.displayName = "DropdownIconButton"
